import React, { FC, useContext, useMemo, useState } from 'react'

import { useParams } from 'react-router'
import { cloneDeep } from 'lodash'

import InfiniteScrollDataTable from '../../../../../../../components/common/tables/InfiniteScrollDataTable'
import ViewsLoader from '../../../../../../../components/loader/ViewsLoader'

import { getColumnsScoring } from './data/columns'
import { useEventTrainers } from '../../../../../../../hooks/useEventTrainers'
import { convertTime } from '../../../../../../../helpers/time'
import { onRank } from './data/scoring-utils'

import FirestoreService from '../../../../../../../services/firestoreService'

import { HandleModalContext } from '../../../../../../../layout/mainlayout/MainLayout'

import { RegistrationByDayModel } from '../../../../../../../models/registrations-by-day/registrationByDay.model'

import { IBreakRegistrationByDay } from '../../../../../../../models/events/event.interface'
import { RegistrationFeesType } from '../../../../../../../models/event-fees/event-fees.interface'
import { IRegistrationByDayInterface } from '../../../../../../../models/registrations-by-day/registrationByDay.interface'
import { IRegistrationByDayEx, RegistrationFeesTypeEx } from '../../ManageClinicNOtherOperationsTab'
import { IManageOption } from '../../types/IManageOption'

import { sortByTotalPoints } from '../../data/operations-tab-utils'

import { MODAL_CONSTS } from '../../../../../../../const/modal-const'
import { CONST } from '../../../../../../../const/const'

const COLLECTIONS = CONST.DATA.FIRESTORE.LATEST.COLLECTIONS

interface ScoringTableByClassProps {
  registrationsByDayByClass: IBreakRegistrationByDay[]
  updateFeesKeys: (keys: object, uuid: string, parentId?: string) => Promise<void>
  fee: RegistrationFeesType | null
  selectedClass: IManageOption | null
  increment: string
  getRegistrationsByDay: () => Promise<IRegistrationByDayInterface[]>
  registrationsByDay: IRegistrationByDayInterface[] | null
  setRegistrationsByDay: (value: IRegistrationByDayInterface[]) => void
  onChangeJudge: (
    row: RegistrationFeesTypeEx,
    values: { label: string; value: string }[]
  ) => Promise<void>
}
export const ScoringTableByClass: FC<ScoringTableByClassProps> = ({
  registrationsByDayByClass,
  updateFeesKeys,
  fee,
  selectedClass,
  increment,
  getRegistrationsByDay,
  setRegistrationsByDay,
  registrationsByDay,
  onChangeJudge,
}) => {
  const { eventId } = useParams<{ eventId: string }>()
  const [loading, setLoading] = useState(false)
  const { eventTrainers } = useEventTrainers(eventId)

  const handleModalContext = useContext(HandleModalContext)

  const [scoringLoading, setScoringLoading] = useState(false)

  const registrationsToDisplay = useMemo(() => {
    return [...registrationsByDayByClass]
  }, [registrationsByDayByClass])

  const onSortScore = async (isAsc: boolean) => {
    setLoading(true)
    let sortedRegistrations = sortByTotalPoints(
      cloneDeep(registrationsByDay) ?? [],
      isAsc ? 'asc' : 'desc'
    )

    let count = 0

    // update rank for all registrations that have the same class
    sortedRegistrations = sortedRegistrations?.map((registrationByDay) => {
      if (selectedClass?.value === registrationByDay.uuid) {
        count++
        return {
          ...registrationByDay,
          ...(registrationByDay.score && {
            score: { ...registrationByDay.score, rank: count },
          }),
        }
      } else {
        return registrationByDay
      }
    })

    setRegistrationsByDay([...sortedRegistrations])

    await updateFeesKeys({ isAsc }, selectedClass?.value || '', selectedClass?.parentId)

    // Update firestore collection
    if (sortedRegistrations?.length) {
      await Promise.all(
        sortedRegistrations.map((registrationByDay) => {
          const item = new RegistrationByDayModel(registrationByDay)
          return FirestoreService.updateItem(
            COLLECTIONS.REGISTRATION_BY_DAY.NAME,
            item.id,
            item.toFirestore()
          )
        })
      )
    }
    setLoading(false)
  }

  const onScore = (row: IRegistrationByDayEx) => {
    if (row.score?.sheet?.type === 'hunter-jumper') {
      handleModalContext?.handleModal(true, MODAL_CONSTS.CUSTOM_SCORING, {
        modalTitle: 'Results',
        rider: row,
        onSaveScoring: () => getRegistrationsByDay(),
        editable: true,
      })
    } else {
      handleModalContext?.handleModal(true, MODAL_CONSTS.SCORING, {
        rider: row,
        onSaveScoring: () => getRegistrationsByDay(),
        editable: true,
      })
    }
  }

  const getTime = ({ index }: { index: number }) => {
    if (increment) {
      return convertTime(
        `${fee?.startTimeHours}:${fee?.startTimeMinutes} ${fee?.startTimeFormat}`,
        increment,
        index
      )
    } else {
      return '00:00:00 AM'
    }
  }

  return (
    <div className={'relative'}>
      <InfiniteScrollDataTable
        hasMore={false}
        className="exhibitorListTable"
        columns={getColumnsScoring({
          type: 'class',
          eventTrainers,
          registrationsByDay,
          setRegistrationsByDay,
          scoringLoading,
          getTime,
          fee,
          onSortScore,
          onScore,
          onRank: (row, fee) =>
            onRank({
              row,
              fee,
              setScoringLoading,
              getRegistrationsByDay,
              handleModalContext,
              onChangeJudge,
            }),
        })}
        data={registrationsToDisplay}
      />
      {loading && (
        <div
          className={
            'absolute top-0 left-0 w-full h-full flex justify-center items-center bg-white/50'
          }
        >
          <ViewsLoader />
        </div>
      )}
    </div>
  )
}
